import React, { useEffect, useState } from 'react';
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import styles from "./detailedview.module.scss";
import CXScore from "./Tiles/CXScore";
import CAS from "./Tiles/CAS";
import { Spin } from 'antd';
import CXList from './Tiles/CXList';
import * as utils from '../../utils/utils';
import * as consts from '../../utils/constant';
import * as favUtils from '../../utils/favorite.utils';
import Attributes from '../attributes/SBS';
import * as constants from "../../../src/utils/constant";

const SBS = (props) => {

    const favInput = JSON.parse(JSON.stringify(props.favInput));
    const { selectedProductDivision } = props;
    const { selectedSBS } = props;
    let [FavoriteId, setFavoriteId] = useState(null)
    const [loading, setLoading] = useState(false)
    const [sbsDetails, setSbsDetails] = useState(null)
    const recommended = selectedSBS.recommendation.toLocaleLowerCase()

    const breadcrumbList = [
        {
            value: "Dashboard",
            path: "/dashboard",
        },
        {
            value: selectedProductDivision.code,
            path: "/dashboard/productdivision",
        },
        {
            value: selectedSBS.code,
            path: "/",
        },
    ];
    const formatData = (result) => {
        let businessUnit = []
        let hitsArray = (result.hits && result.hits.hits && result.hits.hits.length>0)?result.hits.hits[0]:[];
        const productDivision = (hitsArray && hitsArray.inner_hits && hitsArray.inner_hits.productDivisions && hitsArray.inner_hits.productDivisions.hits && hitsArray.inner_hits.productDivisions.hits.hits && hitsArray.inner_hits.productDivisions.hits.hits.length>0)?result.hits.hits[0].inner_hits.productDivisions.hits.hits[0]:[];
        if(productDivision && productDivision['_source'] && productDivision['_source'].businessUnits && productDivision['_source'].businessUnits.length>0){
            const businessUnit = productDivision['_source'].businessUnits.filter(item=>item.code === selectedSBS.code)[0];
            return businessUnit
        }
        return businessUnit
        
    }
    useEffect(() => {
        setLoading(true)
        // utils.getData(`getscoredetails`,
        //     'POST',
        //     {
        //         type: 'sbs',
        //         filePath: 'score_details/sbs/sbs.json',
        //         divisionCode: selectedProductDivision.code,
        //         sbsCode: selectedSBS.code
        //     }).then(resp => {
        //         setSbsDetails(resp.data)
        //         setLoading(false)
        //     }).catch(err => setLoading(false))
        const input = {
            name: constants.SBS_ScoreDetails_Index,
            queryParams: {
                "_source": "false",
                "query": {
                  "nested": {
                    "path": "productDivisions",
                    "query": {
                      "match": {
                        "productDivisions.code": selectedProductDivision.code
                      }
                    },
                    "inner_hits": {
                      
                    }
                  }
                }
              }
            }
        setLoading(true)
          utils.getDataES('-elasticsearch', 'POST',input)
            .then(resp => {
              let groupESData = formatData(resp.data);
              setSbsDetails(groupESData)
              setLoading(false)
            }).catch(err =>  setLoading(false))
    }, [])

    let cxScore, cas, cxList, cxListDP;
    const getSortedCXList = (cxList) => {
        let list = [...cxList]
        list.forEach(element => {
            element.difference = element.score - element.lastQuarterValue
            element.differenceCent = ((element.score - element.lastQuarterValue) / (element.lastQuarterValue)) * 100
        });
        return list.sort(utils.sorting('differenceCent', 'number', false))
    }

    if (sbsDetails) {
        cxScore = sbsDetails.cxScore;
        if(sbsDetails && sbsDetails.cxList && sbsDetails.cxList.length>0){
            cxListDP = sbsDetails.cxList.find(item=>item.name.toLowerCase() === consts.HELD_ORDER_INDEX.toLowerCase());
            cxScore.dataPoints = (cxListDP && cxListDP.dataPoints)?cxListDP.dataPoints:''
        }
        cas = sbsDetails.cas;
        cxList = getSortedCXList(sbsDetails.cxList);
    }

    const createBreadCrumb = () => {
        breadcrumbList[breadcrumbList.length - 1].path = '/dashboard/sbsdetail'
        return breadcrumbList;
    }

    const viewScore = (score) => {
        props.setCXScoreData(sbsDetails);
        props.setBreadCrumb(createBreadCrumb());
        if (score === 'cas') {
            props.setSASParent('cas');
            props.history.push("/dashboard/score/cas");
        } else {
            props.setSASParent('cx');
            props.history.push("/dashboard/score");
        }
    };

    const getInsights = (nba) => {
        if (sbsDetails.nba_insights) {
            let insights = sbsDetails.nba_insights.filter(element => element.metrics_name.toLowerCase() === nba.toLowerCase())
            if (insights && insights.length) {
                return insights[0].insights
            }
            return []
        }
        return []
    }

    const primaryView = (nba) => {
        let _nba;
        const { code } = props.selectedSBS;
        const { code: divisionCode } = props.selectedProductDivision;
        switch (nba) {
            case consts.IMPROVE_INVOICE_AGING:
                _nba = {
                    name: nba,
                    primaryView: `${process.env.REACT_APP_IMPROVE_INVOICE_AGING_PRIMARY_LINK}&filter=Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Salesmetrics/product_division_code eq '${divisionCode}' and Salesmetrics/business_segment_code eq '${code}' and Salesmetrics2/product_division_code eq '${divisionCode}' and Salesmetrics2/business_segment_code eq '${code}' and Salesmetrics2/ship_to_national_sales_group_name eq '-'`,
                    childView: `${process.env.REACT_APP_IMPROVE_INVOICE_AGING_CHILD_LINK}&filter=Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Invoice/product_division_code eq '${divisionCode}' and Invoice/business_segment_code eq '${code}' and Invoice2/product_division_code eq '${divisionCode}' and Invoice2/business_segment_code eq '${code}'`,
                    historyView: `${process.env.REACT_APP_IMPROVE_INVOICE_AGING_HISTORY_LINK}&filter=Invoice/product_division_code eq '${divisionCode}' and Invoice/business_segment_code eq '${code}'`,
                    insights: getInsights(consts.IMPROVE_INVOICE_AGING)
                }
                props.setNBA(_nba)
                break;
            case consts.REDUCE_RETURN_PERCENTAGE:
                _nba = {
                    name: nba,
                    primaryView: `${process.env.REACT_APP_REDUCE_RETURN_PERCENTAGE_PRIMARY_LINK}&filter=Rank/primary_group eq 'Life Sciences' and Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Sales/product_division_code eq '${divisionCode}' and Sales/business_segment_code eq '${code}' and Sales2/product_division_code eq '${divisionCode}' and Sales2/business_segment_code eq '${code}'`,
                    childView: `${process.env.REACT_APP_REDUCE_RETURN_PERCENTAGE_CHILD_LINK}&filter=Rank/primary_group eq 'Life Sciences' and Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Sales/product_division_code eq '${divisionCode}' and Sales/business_segment_code eq '${code}' and Sales2/product_division_code eq '${divisionCode}' and Sales2/business_segment_code eq '${code}'`,
                    historyView: `${process.env.REACT_APP_REDUCE_RETURN_PERCENTAGE_HISTORY_LINK}&filter=Rank/primary_group eq 'Life Sciences' and Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Rank/return_amount_rank le 5 and Sales/product_division_code eq '${divisionCode}' and Sales/business_segment_code eq '${code}'`,
                    insights: getInsights(consts.REDUCE_RETURN_PERCENTAGE)
                }
                props.setNBA(_nba)
                break;
            case consts.IMPROVE_PRODUCT_AVAILABILITY:
                _nba = {
                    name: nba,
                    primaryView: `${process.env.REACT_APP_IMPROVE_PRODUCT_AVAILABILITY_PRIMARY_LINK}&filter=Rank/primary_group eq 'Life Sciences' and Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Salesmetrics/product_division_code eq '${divisionCode}' and Salesmetrics/business_segment_code eq '${code}' and Salesmetrics2/product_division_code eq '${divisionCode}' and Salesmetrics2/business_segment_code eq '${code}' and Salesmetrics2/ship_to_national_sales_group_name eq '-'`,
                    childView: `${process.env.REACT_APP_IMPROVE_PRODUCT_AVAILABILITY_CHILD_LINK}&filter=Rank/primary_group eq 'Life Sciences' and Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Sales/product_division_code eq '${divisionCode}' and Sales/business_segment_code eq '${code}' and Sales2/product_division_code eq '${divisionCode}' and Sales2/business_segment_code eq '${code}'`,
                    historyView: `${process.env.REACT_APP_IMPROVE_PRODUCT_AVAILABILITY_HISTORY_LINK}&filter=Rank/primary_group eq 'Life Sciences' and Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Rank/backorder_rank le 5 and Sales/product_division_code eq '${divisionCode}' and Sales/business_segment_code eq '${code}'`,
                    insights: getInsights(consts.IMPROVE_PRODUCT_AVAILABILITY)
                }
                props.setNBA(_nba)
                break;
            case consts.NEW_IMPROVE_ORDER_VELOCITY:
                _nba = {
                    name: nba,
                    primaryView: `${process.env.REACT_APP_IMPROVE_ORDER_VELOCITY_PRIMARY_LINK}&filter=Rank/primary_group eq 'Life Sciences' and Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Salesmetrics/product_division_code eq '${divisionCode}' and Salesmetrics/business_segment_code eq '${code}' and Salesmetrics2/product_division_code eq '${divisionCode}' and Salesmetrics2/business_segment_code eq '${code}' and Salesmetrics2/ship_to_national_sales_group_name eq '-'`,
                    childView: `${process.env.REACT_APP_IMPROVE_ORDER_VELOCITY_CHILD_LINK}&filter=Rank/primary_group eq 'Life Sciences' and Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Sales/product_division_code eq '${divisionCode}' and Sales/business_segment_code eq '${code}' and Sales2/product_division_code eq '${divisionCode}' and Sales2/business_segment_code eq '${code}'`,
                    historyView: `${process.env.REACT_APP_IMPROVE_ORDER_VELOCITY_HISTORY_LINK}&filter=Rank/primary_group eq 'Life Sciences' and Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Rank/order_cycle_time_rank le 5 and Sales/product_division_code eq '${divisionCode}' and Sales/business_segment_code eq '${code}'`,
                    insights: getInsights(consts.NEW_IMPROVE_ORDER_VELOCITY)
                }
                props.setNBA(_nba)
                break;
            case consts.IMPROVE_OTIF:
                _nba = {
                    name: nba,
                    primaryView: `${process.env.REACT_APP_IMPROVE_OTIF_PRIMARY_LINK}&filter=Rank/primary_group eq 'Life Sciences' and Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Salesmetrics/product_division_code eq '${divisionCode}' and Salesmetrics/business_segment_code eq '${code}' and Salesmetrics2/product_division_code eq '${divisionCode}' and Salesmetrics2/business_segment_code eq '${code}' and Salesmetrics2/ship_to_national_sales_group_name eq '-'`,
                    childView: `${process.env.REACT_APP_IMPROVE_OTIF_CHILD_LINK}&filter=Rank/primary_group eq 'Life Sciences' and Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Sales/product_division_code eq '${divisionCode}' and Sales/business_segment_code eq '${code}' and Sales2/product_division_code eq '${divisionCode}' and Sales2/business_segment_code eq '${code}'`,
                    historyView: `${process.env.REACT_APP_IMPROVE_OTIF_HISTORY_LINK}&filter=Rank/primary_group eq 'Life Sciences' and Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Rank/revenue_rank le 5 and Sales/product_division_code eq '${divisionCode}' and Sales/business_segment_code eq '${code}'`,
                    insights: getInsights(consts.IMPROVE_OTIF)
                }
                props.setNBA(_nba)
                break;
            case consts.INCREASE_CREDITLINE:
                _nba = {
                    name: nba,
                    primaryView: `${process.env.REACT_APP_INCREASE_CREDITLINE_PRIMARY_LINK}&filter=Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Salesmetrics/product_division_code eq '${divisionCode}' and Salesmetrics/business_segment_code eq '${code}' and Salesmetrics2/product_division_code eq '${divisionCode}' and Salesmetrics2/business_segment_code eq '${code}' and Salesmetrics2/ship_to_national_sales_group_name eq '-'`,
                    childView: `${process.env.REACT_APP_INCREASE_CREDITLINE_CHILD_LINK}&filter=Rank/product_division_code eq '${divisionCode}' and Rank/business_segment_code eq '${code}' and Salesmetrics2/product_division_code eq '${divisionCode}' and Salesmetrics2/business_segment_code eq '${code}' and Salesmetrics2/ship_to_national_sales_group_name eq '-' and Invoice/product_division_code eq '${divisionCode}' and Invoice/business_segment_code eq '${code}' and Invoice2/product_division_code eq '${divisionCode}' and Invoice2/business_segment_code eq '${code}'`,
                    historyView: `${process.env.REACT_APP_INCREASE_CREDITLINE_HISTORY_LINK}`,
                    insights: getInsights(consts.IMPROVE_OTIF)
                }
                props.setNBA(_nba)
                break;
            default:
                break;
        }

        props.setNBABreadCrumb(createBreadCrumb())
        props.history.push('/dashboard/nba/primaryview')
    }

    async function getFavorites() {
        const favorites = await favUtils.getFavorites()
        props.setFavorite(favorites)
    }

    async function addToFavorite(isAlreadyFavorite) {
        try {
            setLoading(true)
            if (!isAlreadyFavorite) {
                favInput.UserId = utils.getUserEmail()
                favInput.ViewType = 1
                favInput.InputParameters.productDivision = props.selectedProductDivision;
                favInput.InputParameters.sbs = selectedSBS;
                const FavoriteId = await favUtils.addFavorites(favInput)
                setFavoriteId(FavoriteId)
            } else {
                await favUtils.removeFavorites(FavoriteId)
                setFavoriteId(null)
            }
            setLoading(false)
            getFavorites()
        } catch (err) {
            console.log(err);
            setLoading(false)
        }
    }

    useEffect(() => {
        setFavoriteId(favUtils.chkIsFavorite(
            props.favorites,
            1,
            selectedProductDivision,
            {},
            selectedSBS))
    }, [])

    const nbas = [
        {
            nba: consts.REDUCE_RETURN_PERCENTAGE,
            recommended: recommended === consts.REDUCE_RETURN_PERCENTAGE.toLowerCase() ? true : false
        },
        {
            nba: consts.IMPROVE_PRODUCT_AVAILABILITY,
            recommended: recommended === consts.IMPROVE_PRODUCT_AVAILABILITY.toLowerCase() ? true : false
        },
        {
            nba: consts.NEW_IMPROVE_ORDER_VELOCITY,
            recommended: recommended === consts.NEW_IMPROVE_ORDER_VELOCITY.toLowerCase() ? true : false
        },
        {
            nba: consts.IMPROVE_OTIF,
            recommended: recommended === consts.IMPROVE_OTIF.toLowerCase() ? true : false
        },
        {
            nba: consts.IMPROVE_INVOICE_AGING,
            recommended: recommended === consts.IMPROVE_INVOICE_AGING.toLowerCase() ? true : false
        },
        {
            nba: consts.INCREASE_CREDITLINE,
            recommended: recommended === consts.INCREASE_CREDITLINE.toLowerCase() ? true : false
        }
    ]

    return (
        <Spin spinning={loading}>
            <div className={styles.cxContainer}>
                <BreadCrumb
                    list={breadcrumbList}
                    {...props}
                    addToFavorite={addToFavorite}
                    isFavorite={FavoriteId ? true : false} />
                <div className="row no-gutters">
                    <div className={`${styles.leftContent} ${"col-sm-12 col-md-12 col-lg-8"}`}>
                        {
                            sbsDetails ?
                                <React.Fragment>
                                    <div className={styles.scoreGrid}>
                                        {cxScore && <CXScore cxScore={cxScore} {...props} viewScore={viewScore} />}
                                        {cas && <CAS cas={cas} {...props} viewScore={viewScore} />}
                                        {cxList && <CXList cxList={cxList} {...props} />}
                                    </div>
                                    <div className={styles.layoutBx}>
                                        <h2 className={styles.cxHeading}>Journey Map Score</h2>
                                        <div className={styles.underDesign}>Under Design</div>
                                    </div>
                                    <div className={styles.layoutBx}>
                                        <h2 className={styles.cxHeading}>Next Best Actions</h2>
                                        <div className={styles.nbaContainer}>
                                            {
                                                nbas.map((element, index) => (
                                                    <div
                                                        key={index}
                                                        onClick={() => primaryView(element.nba)}
                                                        className={element.recommended ? `${styles.griditem} ${styles.recommended}` : styles.griditem}>{element.nba}</div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </React.Fragment> : null
                        }
                    </div>
                    <div className={`${styles.rightContent} ${"col-sm-12 col-md-12 col-lg-4"}`}>
                        <Attributes code={selectedSBS.code} divisionCode={selectedProductDivision.code} />
                    </div>
                </div>
            </div>
        </Spin>
    );
};

export default SBS;
